import { useQuery } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import CustomerService, {
  CustomersQueryFilterDto,
} from '@/services/CustomerService';

export const GET_CUSTOMERS_PAGINATED_KEY = (
  customersQueryFilterDto?: CustomersQueryFilterDto,
) => ['paginated-customers', customersQueryFilterDto];

export function useGetPaginatedCustomers(
  customersQueryFilterDto: CustomersQueryFilterDto,
) {
  const queryClient = useQueryClient();
  const { page, limit } = customersQueryFilterDto;
  const { data, isFetching } = useQuery({
    queryKey: GET_CUSTOMERS_PAGINATED_KEY(customersQueryFilterDto),
    queryFn: () => CustomerService.getAllCustomers(customersQueryFilterDto),
  });

  useEffect(() => {
    if (data && page < data?.totalPages) {
      const nextPage = page + 1;
      const customersQueryFilterNext = {
        ...customersQueryFilterDto,
        page: nextPage,
      };
      const nextQueryKey = GET_CUSTOMERS_PAGINATED_KEY(
        customersQueryFilterNext,
      );
      if (!queryClient.getQueryData(nextQueryKey)) {
        queryClient.prefetchQuery({
          queryKey: nextQueryKey,
          queryFn: () =>
            CustomerService.getAllCustomers(customersQueryFilterNext),
        });
      }
    }
  }, [data, page, limit, customersQueryFilterDto, queryClient]);

  return {
    customers: data?.items || [],
    totalPages: data?.totalPages || 1,
    isLoading: isFetching,
  };
}
